import React from 'react';

//Templates
const JourneyBuilder = React.lazy(() => import("../../templates/JourneyBuilder/JourneyBuilder"));
const JourneysList = React.lazy(() => import('../../templates/JourneyBuilder/JourneysList'));
const Login = React.lazy(() => import("../../templates/Login/Login"));
const Home = React.lazy(() => import('../../templates/Home'));
const PricingScreen = React.lazy(() => import("../../templates/Pricing/Pricing"));


const CustomerLayout = React.lazy(() => import('../../templates/CustomerLayout/CustomerLayout'));
const MoveIncludes = React.lazy(() => import('../../templates/MoveIncludes'));
const Deposit = React.lazy(() => import("../../templates/Deposit/Deposit"));
const BackHaulMatchPrice = React.lazy(() => import('../../templates/BackHaulPrice/BackHaulPrice'));

const ScheduleCall = React.lazy(() => import("../../templates/ScheduleCall/ScheduleCall"));
const ScriptWithCard = React.lazy(() => import("../../templates/ScriptWithCard"));
const Ratings = React.lazy(() => import('../../templates/Ratings'));
const FlexiDateContainer = React.lazy(() => import('../../templates/FlexiDateTemplate'));
const FlateRatePrice = React.lazy(() => import('../../templates/FlatRatePrice/FlatRatePrice'));
const JustInCase = React.lazy(() => import('../../templates/JustInCase/JustInCase'));
const GreatView = React.lazy(() => import('../../templates/GreatView/GreatView'));

const templatesLibrary: any = {
	"JourneyBuilder": JourneyBuilder,
	"JourneysList": JourneysList,
	"Login": Login,
	"Home": Home,
	"MoveIncludes": MoveIncludes,
	"Ratings": Ratings,
	"CustomerLayout": CustomerLayout,
	"PricingScreen": PricingScreen,
	"Deposit": Deposit,
	"BackHaulMatchPrice": BackHaulMatchPrice,
	"ScheduleCall": ScheduleCall,
	"ScriptWithCard": ScriptWithCard,
	"FlexiDateContainer": FlexiDateContainer,
	"FlatRatePrice": FlateRatePrice,
	"JustInCase": JustInCase,
	"GreatView": GreatView
}

export const defaultProps: any = {
	"JourneyBuilder": { status: 0 },
	"JourneysList": { status: 0 },
	"MockTemplate": { status: 0 },
	"Login": { status: 0 },
}

export default templatesLibrary;